import { createContext } from 'react';

const ChatContext= createContext();

export { ChatContext };
